import { Link } from "react-router-dom";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import SectionTitle from "@/components/base/SectionTitle";
import PlotCard from "@/components/feature/PlotCard";
import CastCard from "@/components/feature/CastCard";
import ReviewCard from "@/components/feature/ReviewCard";
import HeroSection from "./components/HeroSection";
import NewsSidebar from "./components/NewsSidebar";
import RecommendSidebar from "./components/RecommendSidebar";
import { plotItems, castItems, reviewItems } from "@/mocks/content";

const seeMoreClass =
  "flex items-center gap-1 whitespace-nowrap text-xs text-primary-600 transition-colors hover:text-primary-700 md:text-sm";

export default function Home() {
  useDocumentMeta({
    title: "我的朋友他的妻子-影视剧剧情介绍与精彩点评",
    description:
      "我的朋友他的妻子官网，提供该影视剧的剧情介绍、演员信息、精彩剧评及最新动态，方便用户了解和追踪剧集内容。",
    keywords: "我的朋友他的妻子,影视剧,剧情介绍,演员信息,剧评,影视专题。",
    canonical: "https://w8gp.cn/",
  });

  const featuredPlots = [...plotItems].sort((a, b) => a.order - b.order).slice(0, 3);
  const featuredCast = castItems.slice(0, 4);
  const featuredReviews = reviewItems.slice(0, 3);

  return (
    <>
      <HeroSection />

      <div className="mx-auto w-full max-w-content px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-8">
          <div className="flex flex-col gap-14 lg:col-span-2">
            <section>
              <SectionTitle
                title="剧情介绍精选"
                subtitle="从雨夜重逢到写给未来的信，回顾每一集的关键情节"
                action={
                  <Link to="/category/plot" className={seeMoreClass}>
                    查看更多剧情
                    <i className="ri-arrow-right-s-line"></i>
                  </Link>
                }
              />
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {featuredPlots.map((item) => (
                  <PlotCard key={item.id} item={item} />
                ))}
              </div>
            </section>

            <section>
              <SectionTitle
                title="演员明星"
                subtitle="走近角色背后的表演者"
                action={
                  <Link to="/category/cast" className={seeMoreClass}>
                    全部演员
                    <i className="ri-arrow-right-s-line"></i>
                  </Link>
                }
              />
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
                {featuredCast.map((item) => (
                  <CastCard key={item.id} item={item} />
                ))}
              </div>
            </section>

            <section>
              <SectionTitle
                title="精彩剧评精选"
                subtitle="来自影评人与观众的多元解读"
                action={
                  <Link to="/category/reviews" className={seeMoreClass}>
                    全部剧评
                    <i className="ri-arrow-right-s-line"></i>
                  </Link>
                }
              />
              <div className="flex flex-col gap-4">
                {featuredReviews.map((item) => (
                  <ReviewCard key={item.id} item={item} />
                ))}
              </div>
            </section>
          </div>

          <aside className="flex flex-col gap-6">
            <NewsSidebar />
            <RecommendSidebar />
          </aside>
        </div>
      </div>
    </>
  );
}